const dayString = sale => `prop-${sale.day.replace(/-/gi, '')}`;
const availTimes = (pkg, sale) => {
  var day = pkg.available_dates.root[dayString(sale)];
  return day == null ? null : day['prop-a'] ? null : day;
};

export default availTimes;
